var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',_vm._g(_vm._b({style:({ '--direction': _vm.styleDirection }),attrs:{"name":"fade-slide","mode":_vm.mode}},'transition',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }